export const ROUTE_LINE_STYLES = {
  DEFAULT: {
    WIDTH: 1,
    OPACITY: 0.7,
    DASH_ARRAY: [2, 3]
  },
  SELECTED: {
    WIDTH: 4,
    OPACITY: 1,
    DASH_ARRAY: [1, 0]
  }
};

export const ROUTE_COLORS = [
  '#0E9EFF', // Blue
  '#FF5252', // Red
  '#DD53FF', // Pink
  '#FFD465', // Yellow
  '#FFDAF9', // Light pink
  '#4BAC3C', // Green
  '#A47AFF', // Purple
  '#E3FFA7', // Light green
  '#F8A457', // Orange
  '#1557FF', // Dark blue
  '#80DFEB', // Light blue
  '#00BFA5', // Teal
  '#FF9800', // Amber
  '#9C27B0', // Deep Purple
  '#607D8B', // Blue Grey
  '#8BC34A', // Light Green
  '#FF4081', // Pink Accent
  '#3F51B5', // Indigo
  '#FFEB3B', // Yellow
  '#795548' // Brown
];
